@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
  ></mat-progress-spinner>
}

<!-- Modern Expandable Table -->
@if (!loading()) {
  <table class="fees-table">
    <tr>
      <th
        class="header-cell"
        style="width: 40px"
      ></th>
      <th class="header-cell">Partner</th>
      <th
        class="header-cell"
        style="width: 175px"
      >
        Termék
      </th>
      <th class="header-cell">Darabszám</th>
      <th class="header-cell">Payee szolgáltatási díj végösszeg (ügyindítás - visszatérítés)</th>
      <th class="header-cell">Payee szolgáltatási díj ügyindítás összeg</th>
      <th class="header-cell">Payee szolgáltatási díj visszatérítés összeg</th>
    </tr>
    @if ((feeSums | keyvalue).length === 0) {
      <tr class="no-data">
        <td colspan="7">Nincs adat a megjelenítéshez</td>
      </tr>
    }
    @for (partnerRow of feeSums | keyvalue; track partnerRow.key) {
      <tr
        class="partner-group"
        (click)="togglePartner(partnerRow.value)"
      >
        <td class="expand-icon">
          <mat-icon>
            {{ isPartnerExpanded(partnerRow.value) ? "expand_less" : "expand_more" }}
          </mat-icon>
        </td>
        <td class="partner-name">{{ partnerRow.value.partner }}</td>
        <td class="summary-cell"></td>
        <td class="summary-cell">{{ partnerRow.value.count }}</td>
        <td class="summary-cell total-fee">
          <span>Bruttó</span>
          @for (fee of partnerRow.value.final_fee_sums | keyvalue; track fee.key; let last = $last) {
            <span>
              {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
              @if (!last) {
                <span>|</span>
              }
            </span>
          }
        </td>
        <td class="summary-cell">
          <span>Bruttó</span>
          @for (fee of partnerRow.value.start_fee_sums | keyvalue; track fee.key; let last = $last) {
            <span>
              {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
              @if (!last) {
                <span>|</span>
              }
            </span>
          }
        </td>
        <td class="summary-cell">
          <span>Bruttó</span>
          @for (fee of partnerRow.value.reject_fee_sums | keyvalue; track fee.key; let last = $last) {
            <span>
              {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
              @if (!last) {
                <span>|</span>
              }
            </span>
          }
        </td>
      </tr>
      @if (isPartnerExpanded(partnerRow.value)) {
        @for (detailRow of fees[partnerRow.value.partner]; track detailRow.partner) {
          <tr class="detail-row">
            <td class="detail-cell"></td>
            <td class="detail-cell"></td>
            <td class="detail-cell product-name">{{ detailRow.product_name }}</td>
            <td class="detail-cell">{{ detailRow.count }}</td>
            <td class="detail-cell total-fee">
              <span>Bruttó</span>
              @for (fee of detailRow.final_fee_sums | keyvalue; track fee.key; let last = $last) {
                <span>
                  {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
                  @if (!last) {
                    <span>|</span>
                  }
                </span>
              }
            </td>
            <td class="detail-cell">
              <span>Bruttó</span>
              @for (fee of detailRow.start_fee_sums | keyvalue; track fee.key; let last = $last) {
                <span>
                  {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
                  @if (!last) {
                    <span>|</span>
                  }
                </span>
              }
            </td>
            <td class="detail-cell">
              <span>Bruttó</span>
              @for (fee of detailRow.reject_fee_sums | keyvalue; track fee.key; let last = $last) {
                <span>
                  {{ fee.value | currency: fee.key : "symbol" : "1.0-0" : "hu" }}
                  @if (!last) {
                    <span>|</span>
                  }
                </span>
              }
            </td>
          </tr>
        }
      }
    }
  </table>
}
